import i18n from '@/plugins/i18n';

// PHONE_TYPES is function maded to translate text after changing lang.
// To use it in components type PHONE_TYPES()

const PHONE_TYPES = () => [
  {
    text: i18n.t('constants.phoneType.phone'),
    value: 'Phone',
  },
  {
    text: i18n.t('constants.phoneType.office'),
    value: 'Office',
  },
  {
    text: i18n.t('constants.phoneType.fax'),
    value: 'Fax',
  },
];

export default PHONE_TYPES;
